import { css } from 'linaria';
import { breakpoints } from 'common/styles/breakpoints';

export const breadCrumbs = css`
  padding: 0;
  margin-bottom: var(--space-250) !important;

  ${breakpoints.from.desktop} {
    margin: var(--space-325) 0 !important;
  }
`;
